export const codes: { [code: string]: string } = {};
codes['H90'] = 'Conductive and sensorineural hearing loss';
codes['H90.0'] = 'Conductive hearing loss, bilateral';
codes['H90.1'] = 'Conductive hearing loss, unilateral with unrestricted hearing on the contralateral side';
codes['H90.11'] = 'Conductive hearing loss, unilateral, right ear, with unrestricted hearing on the contralateral side';
codes['H90.12'] = 'Conductive hearing loss, unilateral, left ear, with unrestricted hearing on the contralateral side';
codes['H90.2'] = 'Conductive hearing loss, unspecified'; //Not used
codes['H90.3'] = 'Sensorineural hearing loss, bilateral';
codes['H90.4'] = 'Sensorineural hearing loss, unilateral with unrestricted hearing on the contralateral side';
codes['H90.41'] = 'Sensorineural hearing loss, unilateral, right ear, with unrestricted hearing on the contralateral side';
codes['H90.42'] = 'Sensorineural hearing loss, unilateral, left ear, with unrestricted hearing on the contralateral side';
codes['H90.5'] = 'Unspecified sensorineural hearing loss';
codes['H90.6'] = 'Mixed conductive and sensorineural hearing loss, bilateral';
codes['H90.7'] = 'Mixed conductive and sensorineural hearing loss, unilateral with unrestricted hearing on the contralateral side';
codes['H90.71'] =
    'Mixed conductive and sensorineural hearing loss, unilateral, right ear, with unrestricted hearing on the contralateral side';
codes['H90.72'] =
    'Mixed conductive and sensorineural hearing loss, unilateral, left ear, with unrestricted hearing on the contralateral side';
codes['H90.8'] = 'Mixed conductive and sensorineural hearing loss, unspecified'; //Not used
codes['H90.A'] = 'Conductive and sensorineural hearing loss with restricted hearing on the contralateral side';
codes['H90.A1'] = 'Conductive hearing loss, unilateral, with restricted hearing on the contralateral side';
codes['H90.A11'] = 'Conductive hearing loss, unilateral, right ear with restricted hearing on the contralateral side';
codes['H90.A12'] = 'Conductive hearing loss, unilateral, left ear with restricted hearing on the contralateral side';
codes['H90.A2'] = 'Sensorineural hearing loss, unilateral, with restricted hearing on the contralateral side';
codes['H90.A21'] = 'Sensorineural hearing loss, unilateral, right ear, with restricted hearing on the contralateral side';
codes['H90.A22'] = 'Sensorineural hearing loss, unilateral, left ear, with restricted hearing on the contralateral side';
codes['H90.A3'] = 'Mixed conductive and sensorineural hearing loss, unilateral with restricted hearing on the contralateral side';
codes['H90.A31'] =
    'Mixed conductive and sensorineural hearing loss, unilateral, right ear with restricted hearing on the contralateral side';
codes['H90.A32'] =
    'Mixed conductive and sensorineural hearing loss, unilateral, left ear with restricted hearing on the contralateral side';

export enum hearingLossType {
    UNSPECIFIED,
    CONDUCTIVE,
    SENSORINEURAL,
    MIXED,
    NONE
}

export enum hearingLossIntensity {
    NORMAL,
    MILD,
    MODERATE,
    MODERATELY_SEVERE,
    SEVERE,
    PROFOUND,
    UNSPECIFIED
}

export enum ear {
    LEFT,
    RIGHT,
    UNSPECIFIED
}

function singleBilateralCode(hearingLoss: hearingLossType) {
    switch (hearingLoss) {
        case hearingLossType.CONDUCTIVE:
            return 'H90.0';
        case hearingLossType.SENSORINEURAL:
            return 'H90.3';
        case hearingLossType.MIXED:
            return 'H90.6';
        case hearingLossType.UNSPECIFIED:
        case hearingLossType.NONE:
            return 'H90';
    }
}

function singleUnilateralCode(hearingLoss: hearingLossType, affectedEar: ear) {
    switch (hearingLoss) {
        case hearingLossType.CONDUCTIVE:
            return affectedEar == ear.UNSPECIFIED ? 'H90.1' : affectedEar == ear.RIGHT ? 'H90.11' : 'H90.12';
        case hearingLossType.SENSORINEURAL:
            return affectedEar == ear.UNSPECIFIED ? 'H90.4' : affectedEar == ear.RIGHT ? 'H90.41' : 'H90.42';
        case hearingLossType.MIXED:
            return affectedEar == ear.UNSPECIFIED ? 'H90.7' : affectedEar == ear.RIGHT ? 'H90.71' : 'H90.72';
        case hearingLossType.UNSPECIFIED:
        case hearingLossType.NONE:
            return 'H90';
    }
}

function singleRestrictedUnilateralCode(hearingLoss: hearingLossType, affectedEar: ear) {
    switch (hearingLoss) {
        case hearingLossType.CONDUCTIVE:
            return affectedEar == ear.UNSPECIFIED ? 'H90.A1' : affectedEar == ear.RIGHT ? 'H90.A11' : 'H90.A12';
        case hearingLossType.SENSORINEURAL:
            return affectedEar == ear.UNSPECIFIED ? 'H90.A2' : affectedEar == ear.RIGHT ? 'H90.A21' : 'H90.A22';
        case hearingLossType.MIXED:
            return affectedEar == ear.UNSPECIFIED ? 'H90.A3' : affectedEar == ear.RIGHT ? 'H90.A31' : 'H90.A32';
        case hearingLossType.UNSPECIFIED:
        case hearingLossType.NONE:
            return 'H90.A';
    }
}

function multipleUnilateralCode(rightHearingLoss: hearingLossType, leftHearingLoss: hearingLossType) {
    return [singleRestrictedUnilateralCode(rightHearingLoss, ear.RIGHT), singleRestrictedUnilateralCode(leftHearingLoss, ear.LEFT)];
}

export default function ICD10Generator(rightHearingLoss: hearingLossType, leftHearingLoss: hearingLossType) {
    //No hearing loss
    if (rightHearingLoss == hearingLossType.NONE && leftHearingLoss == hearingLossType.NONE) return 'H90';

    //Bilateral
    if (rightHearingLoss == leftHearingLoss) return singleBilateralCode(rightHearingLoss);

    //Unilateral, unrestricted right
    if (rightHearingLoss == hearingLossType.NONE) return singleUnilateralCode(leftHearingLoss, ear.LEFT);

    //Unilateral, unrestricted left
    if (leftHearingLoss == hearingLossType.NONE) return singleUnilateralCode(rightHearingLoss, ear.RIGHT);

    return multipleUnilateralCode(rightHearingLoss, leftHearingLoss).join(',');
}
